'use strict';
import React, {PropTypes} from 'react';
// import * as MarketingActions from '../../../actions/MarketingActions.js';
import FormInput from '../FormInput';
import FormTextarea from '../FormTextarea';
import SetterModal from '../SetterModal';
require('es6-promise').polyfill();
// const fetch = require('whatwg-fetch');
import 'whatwg-fetch';
// import fetch from 'isomorphic-fetch';
// import pick from 'lodash/pick';
// import _map from 'lodash/map';

import './styles.scss';

class RequestDemoModal extends React.Component {

  constructor(props, context) {
    super(props, context);
    // this.state = props;
    this.state = {
      isLoading: false,
      errors: [],
    }
    this._onRequestDemo = this._onRequestDemo.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._handleChangeFormInput = this._handleChangeFormInput.bind(this);
  }


  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  _closeModal() {
    this.setState({full_name: "", email: "", company: "", phone: "", comment: "" });
    this.props.onRequestClose();
  }

  /* componentWillReceiveProps
  --===================================================-- */
  componentWillReceiveProps(nextProps) {

  }

  /* MODAL
  --===================================================-- */
  _onRequestDemo(e) {
    console.log("[RequestDemoModal] SAVE BUTTON WAS CLICKED", this.state);

    this.submitCustomerInformation();
  }


  /* Handle a change in an input field
  --===================================================-- */
  _handleChangeFormInput(name, value) {
    var state = {};
    state[name] = value;
    this.setState(state);
  }


  validateRequest() {
    // let vars = pick(this.state, ['full_name', 'email', 'company', 'phone', 'comment']);

    let {full_name, email, company, phone, comment} = this.state,
        vars = {full_name, email, company, phone, comment}

    console.log("[RequestDemoModal] vars", vars);
    return vars;
  }

  /* SUBMIT
  --===================================================-- */
  submitCustomerInformation() {
    console.log("[RequestDemoModal] submitCustomerInformation this.state", this.state);

    let request = this.validateRequest();

    this.setState({isLoading: true});

    // fetch("http://api.setter-production.com/v1/emailer", {
    fetch("http://api.lvh.me:5001/v1/emailer", {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request)
      })
      .then(req => req.json())
      .then(json => {
        if (json.errors === undefined) {
          console.log("[ReqeustDemoModal] success", json);
          this._closeModal();
        } else {
          console.warn("[ReqeustDemoModal] error", json);
          this.setState({errors: json.errors});
        }

        this.setState({isLoading: false});

        // return json;
      })
      .catch(function(error) {
        console.error('requestDemo Request failed, Bummer', error);
      });

    // this.props.dispatch(MarketingActions.requestDemo(this.state)).then((data) => {
    //   // console.log("cretePosition callback", data);
    //   if (data && data.errors === undefined) {
    //     this.setState({responseMessage: "Thanks! We will be in touch very soon."});
    //
    //     setTimeout(function () {
    //       this._closeModal();
    //       this.setState({responseMessage: false});
    //     }.bind(this), 1300);
    //
    //   } else {
    //     console.error("[RequestDemoModal] could not submit Customer", data);
    //     this.setState({errors: data.errors});
    //   }
    // });
  }

  renderModalContent() {

    let errorsNotification;

    if (this.state.errors.length) {
      let errors = this.state.errors.map(function (error, index) {
        return (<div key={index}><strong>{error}</strong></div>);
      })

      errorsNotification = (
        <div className="RequestDemoModal-error">
          {errors}
        </div>
      );
    }


    return (
      <form className="form-padding" acceptCharset="UTF-8">


        <div className="row">
          {errorsNotification}
        </div>

        <div className="row">
          <FormInput
            className="SetterBase-c-12"
            label="Full Name"
            name="full_name" placeholder="Full Name"
            value={this.state.full_name || ""}
            onChange={this._handleChangeFormInput}
            errors={this.state.errors}
            autoFocus
          />
        </div>

        <div className="row">
          <FormInput
            className="SetterBase-c-12"
            label="Email"
            name="email"
            placeholder="your.name@yourcompany.com"
            inputType="email"
            value={this.state.email || ""}
            onChange={this._handleChangeFormInput}
            errors={this.state.errors}
          />
        </div>

        <div className="row">
          <FormInput
            className="SetterBase-c-12"
            label="Phone"
            name="phone" placeholder="(555) 555-5555"
            inputType="tel"
            value={this.state.phone || ""}
            onChange={this._handleChangeFormInput}
            errors={this.state.errors}
          />
        </div>

        <div className="row">
          <FormInput
            className="SetterBase-c-12"
            label="Company"
            name="company" placeholder="Company"
            value={this.state.company || ""}
            onChange={this._handleChangeFormInput}
            errors={this.state.errors}
          />
        </div>

        <div className="row">
          <FormTextarea
            className="SetterBase-c-12"
            label="Comment (optional)"
            name="comment"
            placeholder="Anything you'd like to share or ask?"
            rows={4}
            value={this.state.comment || ""}
            onChange={this._handleChangeFormInput}
            errors={this.state.errors} />
        </div>

      </form>

    );
  }


  render() {
    let buttonText = "Submit",
        modalTitle = "Request a Demo",
        modalContent;

    modalContent = this.state.responseMessage ? (<h3 className="SetterBase-text-center">{this.state.responseMessage}</h3>) : this.renderModalContent();

    return (
        <SetterModal
          isOpen={this.props.isOpen || false}
          confirm={this._onRequestDemo}
          cancel={this._closeModal}
          confirmButtonText={buttonText}
          headerTitleText={modalTitle}
          centerHeaderTitle
          isLoading={this.state.isLoading}
        >
          {modalContent}
        </SetterModal>
    );
  }
}

RequestDemoModal.propTypes = {
  // bucket: React.PropTypes.object
  closeTimeoutMS: PropTypes.number,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

RequestDemoModal.defaultProps = {
  // position: {
  //   id: 0,
  //   title: '',
  //   city: '',
  //   description: '',
  //   country: 'United States',
  //   state_region: '',
  //   errors: {}
  // }
};

RequestDemoModal.displayName = 'RequestDemoModal';

// Which props do we want to inject, given the global state?
// Note: use https://github.com/faassen/reselect for better performance.
function select(state) {
  return {
    // errors: state.appData.people.errors,
    // isLoading: state.appData.positions.isLoading,
    // position: state.appData.positions.activePosition,
  };
}

// Redux - Wrap the component to inject dispatch and state into it
// var LoginConnector = connect(select)(RequestDemoModal);
// export default connect(select)(RequestDemoModal);
export default RequestDemoModal;



/** WEBPACK FOOTER **
 ** ../components/RequestDemoModal/index.js
 **/